import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class InventoryTransfers_ds_get_matching_material_and_lotService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { projectId: number, materialId?: number, materialCode?: string, vendorLotCode?: string, lotCode?: string }): 
  Promise<{ result: { Id?: number, VendorLots?: { Id?: number, Lots?: { Id?: number }[] }[] }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.projectId)) {
      missingRequiredInParams.push('\'projectId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/InventoryTransfers/datasources/ds_get_matching_material_and_lot/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { projectId: number, materialId?: number, materialCode?: string, vendorLotCode?: string, lotCode?: string, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, VendorLots?: { Id?: number, Lots?: { Id?: number }[] }[] }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.projectId)) {
      missingRequiredInParams.push('\'projectId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/InventoryTransfers/datasources/ds_get_matching_material_and_lot/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { projectId: number, materialId?: number, materialCode?: string, vendorLotCode?: string, lotCode?: string, $keys: number[] }): 
  Promise<{ result: { Id?: number, VendorLots?: { Id?: number, Lots?: { Id?: number }[] }[] }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.projectId)) {
      missingRequiredInParams.push('\'projectId\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/InventoryTransfers/datasources/ds_get_matching_material_and_lot/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      projectId: number, materialId?: number, materialCode?: string, vendorLotCode?: string, lotCode?: string    }) {
        if(isNil(inParams.projectId)) {
          return true; 
        }
      return false;
    }
}
